import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Box, Typography } from '@mui/material';
import ButtonUI from '../Interface/ButtonUI';

const ContactSignature = ({ contact, value, onChange }) => {
  const sigRef = useRef();

  const handleClear = () => {
    sigRef.current.clear();
    onChange(contact.value, '');
  };

  const handleEnd = () => {
    const dataUrl = sigRef.current.getCanvas().toDataURL('image/png');
    onChange(contact.value, dataUrl);
  };

  return (
    <Box mb={4}>
      <Typography variant="subtitle1" gutterBottom>
        {contact.label}
      </Typography>
      <SignatureCanvas
        ref={sigRef}
        penColor="black"
        canvasProps={{
          width: 350,
          height: 120,
          className: 'sigCanvas',
          style: { border: '1px solid #ccc', borderRadius: 8 },
        }}
        onEnd={handleEnd}
        backgroundColor="#fff"
      />
      <Box mt={1} display="flex" gap={2}>
        <ButtonUI text="Törlés" onClick={handleClear} color="red" variant="outlined" />
      </Box>
    </Box>
  );
};

export default ContactSignature;
